<script lang="ts">
  /**
   * ReactiveTooltip - A fixed-position tooltip that updates dynamically
   * based on reactive state and cursor position
   */
  interface Props {
    text: string;
    show?: boolean;
    anchorElement?: HTMLElement | undefined;
  }

  let { text, show = false, anchorElement = undefined }: Props = $props();

  let tooltipRef: HTMLDivElement = $state();

  $effect(() => {
    if (tooltipRef && anchorElement && show) {
      const rect = anchorElement.getBoundingClientRect();
      tooltipRef.style.left = `${rect.left}px`;
      tooltipRef.style.top = `${rect.top - 50}px`;
    }
  });
</script>

{#if show && anchorElement}
  <div class="tooltip-portal" bind:this={tooltipRef}>
    {text}
  </div>
{/if}

<style>
  .tooltip-portal {
    position: fixed;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 8px 10px;
    border-radius: 3px;
    font-size: 11px;
    line-height: 1.5;
    white-space: nowrap;
    pointer-events: none;
    z-index: 10000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
</style>
